import type { DocumentLink } from "web_myplann/Portfolio/Types/documentLink";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";
import { parseToPositiveInteger } from "web_myplann/Shared/Utils/parseToPositiveInteger";

export type DocumentUploadOrigin = {
	folder: string | null;
	link: DocumentLink | null;
};

const parseDocumentLink = (
	searchParams: URLSearchParams,
): DocumentLink | null => {
	const portfolioId = parseToPositiveInteger(searchParams.get("portfolioId"));
	if (portfolioId !== undefined) {
		return { kind: PortfolioItemKind.Portfolio, id: portfolioId };
	}

	const propertyId = parseToPositiveInteger(searchParams.get("propertyId"));
	if (propertyId !== undefined) {
		return { kind: PortfolioItemKind.Property, id: propertyId };
	}

	return null;
};

export const parseDocumentUploadOrigin = (
	searchParams: URLSearchParams,
): DocumentUploadOrigin => ({
	folder: searchParams.get("folder") || null,
	link: parseDocumentLink(searchParams),
});
